import { useTranslation } from "next-i18next";
import { FC } from "react";
import Collapsible from "react-collapsible";
import { Container } from "~/components/Container";
import Icon from "~/components/Icon";
import { referralQuestions } from "~/constants/data";
import styles from "../../HomeSections/Questions/Questions.module.scss";
import Trans from "~/types/translationKeys";

const Questions: FC = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className={styles.questions}>
      <Container>
        <h2 className={styles.title} data-aos="fade-up">
          {t(Trans.referral_faqs)}
        </h2>

        <div className={styles.accordion_container}>
          {referralQuestions?.map((item, index) => (
            <Collapsible
              key={index}
              transitionTime={250}
              classParentString={styles.accordion_item}
              triggerWhenOpen={
                <div className={styles.question}>
                  <div className="flex-1">
                    <span className={styles.indexed}>{index + 1}.</span>{" "}
                    {t(item.quesiton)}
                  </div>
                  <Icon name="close" />
                </div>
              }
              trigger={
                <div className={styles.question}>
                  <div className="flex-1">
                    <span className={styles.indexed}>{index + 1}.</span>{" "}
                    {t(item.quesiton)}
                  </div>
                  <Icon name="add" />
                </div>
              }
            >
              <div className={styles.answer}>{t(item.answer)}</div>
            </Collapsible>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Questions;
